import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { toaster } from "../../../../config/toaster";
import { TConfirmation } from "../types";
import CTACardWithConfirmation from "../../../UI/CTACardWithConfirmation";
import CollapsibleInformation from "../../../UI/CollapsibleInformation";
import { useWalletClient } from "wagmi";
import { toastError, toastSuccess } from "../../../../config/toast";
import { chainbridgeConfig } from "../../../../chainbridgeConfig";
import config from "../../../../config/config.json";
import BWLOGO from "../../../../media/logos/pn_logomark_bw.svg";

const configurations = (networkId: number) => {
  const network = config.chains.find(
    (network) => network.networkId === networkId
  );
  return [
    {
      name: "Use the following table to add a custom network RPC manually:",
      title: "Add the Palm Network",
      desc: "Click the button below to add the Palm Network as a custom network in your wallet.",
      buttonCopy: "Add Network",
      collapsibleTitle: "Manually add the network instead",
      table: [
        {
          field: "Network Name",
          input: network && network.name,
        },
        {
          field: "New RPC URL",
          input: [network && network.rpcUrl],
        },
        {
          field: "Chain ID",
          input: parseInt(import.meta.env.VITE_PALM_NETWORK_ID as string),
        },
        {
          field: "Currency Symbol *",
          input: network && network.nativeTokenSymbol,
        },
        {
          field: "Block Explorer URL *",
          input: [network && network.blockExplorer],
        },
      ],
      help: {
        text: "Metamask FAQ: How to add custom Network RPC →",
        url: "https://metamask.zendesk.com/hc/en-us/articles/360043227612-How-to-add-custom-Network-RPC-and-or-Block-Explorer",
      },
      check: "I have added the network",
    },
  ];
};

const AddPalmNetwork = ({ onConfirmation, step }: TConfirmation) => {
  const { data: walletClient } = useWalletClient();
  const [collapse, setCollapse] = useState(false);
  const [validated, setValidated] = useState(false);
  const [networkStatus, setNetworkStatus] = useState(
    configurations(
      parseInt(import.meta.env.VITE_PALM_NETWORK_ID as string)
    ).map((network) => false)
  );

  useEffect(() => {
    if (validated) {
      onConfirmation(step, validated);
    }
  }, [validated]);

  const networkConfirmed = (index: number, checked: boolean) => {
    const newNetworkStatus = [...networkStatus];
    newNetworkStatus[index] = checked;
    setNetworkStatus(newNetworkStatus);
    const enabled = !newNetworkStatus.includes(false);
    setValidated(enabled);
  };

  const onClick = async () => {
    if (!walletClient) return false;
    const networkId = chainbridgeConfig.palmNetwork;
    const chain = chainbridgeConfig.chains.find(
      (c) => c.networkId === networkId
    );
    if (!chain) return false;
    let status = false;
    try {
      await walletClient.addChain({
        chain: {
          id: chain.networkId,
          name: chain.name,
          nativeCurrency: {
            name: chain.nativeTokenSymbol,
            symbol: chain.nativeTokenSymbol,
            decimals: 18,
          },
          rpcUrls: { default: { http: [chain.rpcUrl] } },
          ...(chain.blockExplorer && {
            blockExplorers: {
              default: { name: "Explorer", url: chain.blockExplorer },
            },
          }),
        },
      });
      status = true;
    } catch {
      status = false;
    }
    if (status) {
      setValidated(status);
      toaster.create({
        title: "Network succesfully added to your wallet.",
        type: toastSuccess.status,
        duration: toastSuccess.duration,
      });
      networkConfirmed(step, true);
    } else {
      toaster.create({
        title: "Something was wrong",
        description: "You can add the Palm Network manually to your wallet.",
        type: toastError.status,
        duration: toastError.duration,
      });
      setCollapse(!collapse);
    }
    return status;
  };

  return (
    <>
      {configurations(
        parseInt(import.meta.env.VITE_PALM_NETWORK_ID as string)
      ).map((network, index) => (
        <Box key={`Add-network-${network.name}-card`}>
          <CTACardWithConfirmation
            name={network.name}
            title={network.title}
            desc={network.desc}
            buttonCopy={network.buttonCopy}
            onConfirmation={(index: number, checked: boolean) =>
              networkConfirmed(index, checked)
            }
            index={index}
            check={network.check}
            buttonOnClick={onClick}
            logo={BWLOGO}
            addInformation={
              <CollapsibleInformation
                title={network.collapsibleTitle}
                table={network.table}
                itemName={network.name}
                help={network.help}
                collapse={collapse}
                optional
              />
            }
          />
        </Box>
      ))}
    </>
  );
};
export default AddPalmNetwork;
